import { useInstanceId } from '@adsk/alloy-react-helpers';
export default (id => {
  const uniqueId = useInstanceId();
  return id !== null && id !== void 0 ? id : uniqueId;
});
//# sourceMappingURL=useDropdownId.js.map